document.addEventListener('DOMContentLoaded', function () {
    document.body.addEventListener('click', function (e) {

        if (e.target.matches('.upsell-select-ele')) {

            console.log('123')
            let upsellForms = document.querySelectorAll('.form.upsell-form');



            for (let upsellForm of upsellForms) {
                let inputSelect = upsellForm.querySelector('.product-variant-id');
                let inputQuantity = upsellForm.querySelector('.product-quantity');
                let submitBtn = upsellForm.querySelector('button[type="submit"]');
                let variantSelector = upsellForm.querySelector('select');
                let quantitySelector = upsellForm.querySelector('.quantity__input');

                variantSelector.addEventListener('change', function () {
                    let selectedVariant = variantSelector.value;
                    inputSelect.value = selectedVariant;
                });
            }
        }
    });
});